import React, { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { CountryArray } from "utils/constants";
import { Link } from "gatsby";
import DataProvider from "Context/DataContext";

function FirstStepAccount({ setCurrentStep }) {
  const { firstStepData, setFirstStepData, setCvUpload, cvUpload } =
    useContext(DataProvider);


  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    if (data.password !== data.confirm_password) {
      alert("Password and confirm password should match!");
      return false;
    } else if (data.email !== data.confirm_email) {
      alert("Email and confirm email should match!");
      return false;
    }
    setFirstStepData(data);
    setCurrentStep(2);
  };

  const handleUploadCv = (e) => {
    const files = e.target.files[0];
    setCvUpload(files);
  };

  console.log(cvUpload)

  return (
    <div>
      <div className="rounded-lg bg-black py-5 px-12 h-full mx-4 md:w-10/12 lg:w-9/12 flex flex-col justify-center md:mx-auto max-w-[800px] font-primary">
        <p className="text-center text-white text-xl sm:px-4">
          Please enter the following information.Your information will be kept
          completely{" "}
          <a
            href="https://www.tomedes.com/privacy"
            target="_blank"
            className="text-lightBlue font-semibold"
          >
            confidential.
          </a>
        </p>
        <p className="text-center text-white py-6 font-light">
          Fields marked with an <span className="text-red">*</span> are
          required.
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-6 mb-2">
            <div className="w-full relative">
              <input
                type="text"
                placeholder="First Name*"
                className="rounded pl-3 text-black py-1 w-full"
                id="first_name"
                name="first_name"
                defaultValue={firstStepData.first_name}
                {...register("first_name", { required: true })}
              />
              {errors.first_name && (
                <span className="text-red text-xs absolute left-0 bottom-[-0.25rem]">
                  This field is required
                </span>
              )}
            </div>
            <div className="flex flex-col">
              <input
                type="text"
                placeholder="Last Name"
                className="rounded pl-3 text-black py-1"
                id="last_name"
                name="last_name"
                defaultValue={firstStepData.last_name}
                {...register("last_name", { required: true })}
              />
              {errors.last_name && (
                <span className="text-red text-xs mt-[2px]">
                  This field is required
                </span>
              )}
            </div>
            <div className="flex flex-col">
              <input
                type="text"
                placeholder="Business Name"
                className="rounded pl-3 text-black py-1"
                id="business_name"
                name="business_name"
                defaultValue={firstStepData.business_name}
                {...register("business_name", { required: true })}
              />
              {errors.business_name && (
                <span className="text-red text-xs mt-[2px]">
                  This field is required
                </span>
              )}
            </div>
            <div className="w-full relative flex flex-col">
              <p className="text-xs text-white absolute top-[-16px]">
                Upload your CV*
              </p>
              <input
                type="file"
                placeholder=""
                className="rounded pl-3 text-black py-1 bg-white"
                id="cv_file"
                name="cv_file"
                defaultValue={cvUpload}
                {...register("cv_file" , {required: true})}
                onChange={handleUploadCv}
              />
              {errors.cv_file && (
                <span className="text-red text-xs mt-[2px]">
                  This field is required
                </span>
              )}
            </div>
            <input
              type="text"
              placeholder="Link to Proz"
              className="rounded pl-3 text-black py-1"
              id="link_to_proz"
              name="link_to_proz"
              defaultValue={firstStepData.link_to_proz}
              {...register("link_to_proz")}
            />
            <div className="w-full relative">
              <input
                type="text"
                placeholder="Desired username*"
                className="rounded pl-3 text-black py-1 w-full"
                id="username"
                name="username"
                defaultValue={firstStepData.username}
                {...register("username", { required: true })}
              />
              {errors.username && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <div className="w-full relative">
              <input
                type="email"
                placeholder="E-Mail*"
                className="rounded pl-3 text-black py-1 w-full"
                id="email"
                name="email"
                defaultValue={firstStepData.email}
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <div className="w-full relative">
              <input
                type="email"
                placeholder="Confirm E-Mail*"
                className="rounded pl-3 text-black py-1 w-full"
                id="confirm_email"
                name="confirm_email"
                defaultValue={firstStepData.confirm_email}
                {...register("confirm_email", { required: true })}
              />
              {errors.confirm_email && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <div className="w-full relative">
              <input
                type="password"
                placeholder="Password*"
                className="rounded pl-3 text-black py-1 w-full"
                id="password"
                name="password"
                defaultValue={firstStepData.password}
                {...register("password", { required: true })}
              />
              {errors.password && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <div className="w-full relative">
              <input
                type="password"
                placeholder="Confirm Password*"
                className="rounded pl-3 text-black py-1 w-full"
                id="confirm_password"
                name="confirm_password"
                defaultValue={firstStepData.confirm_password}
                {...register("confirm_password", { required: true })}
              />
              {errors.confirm_password && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <input
              type="text"
              placeholder="Web Address"
              className="rounded pl-3 text-black py-1"
              id="web_address"
              name="web_address"
              defaultValue={firstStepData.web_address}
              {...register("web_address")}
            />
            <input
              type="text"
              placeholder="Telephone Number"
              className="rounded pl-3 text-black py-1"
              id="phone_number"
              name="phone_number"
              defaultValue={firstStepData.phone_number}
              {...register("phone_number")}
            />
            <div className="w-full relative">
              <input
                type="text"
                placeholder="Address*"
                className="rounded pl-3 text-black py-1 w-full"
                id="address"
                name="address"
                defaultValue={firstStepData.address}
                {...register("address", { required: true })}
              />
              {errors.address && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <div className="w-full relative">
              <input
                type="text"
                placeholder="City*"
                className="rounded pl-3 text-black py-1 w-full"
                id="city"
                name="city"
                defaultValue={firstStepData.city}
                {...register("city", { required: true })}
              />
              {errors.city && (
                <span className="text-red text-xs absolute left-0 -bottom-5">
                  This field is required
                </span>
              )}
            </div>
            <div className="flex flex-col">
              <input
                type="text"
                placeholder="State"
                className="rounded pl-3 text-black py-1"
                id="state"
                name="state"
                defaultValue={firstStepData.state}
                {...register("state", { required: true })}
              />
              {errors.state && (
                <span className="text-red text-xs ">
                  This field is required
                </span>
              )}
            </div>
            <select
              className="rounded pl-3 text-black py-1"
              id="country"
              name="country"
              {...register("country")}
              defaultValue={firstStepData.country}
            >
              <option className="text-gray-700 text-lg" disabled selected>
                Select Country
              </option>
              {CountryArray
                ? CountryArray.map(({ name }, index) => (
                    <option
                      key={index}
                      value={name}
                      className="text-gray-700 text-lg"
                    >
                      {name}
                    </option>
                  ))
                : null}
            </select>
            <div className="flex flex-col">
              <input
                type="text"
                placeholder="Zip Code"
                className="rounded pl-3 text-black py-1"
                id="zipcode"
                name="zipcode"
                defaultValue={firstStepData.zipcode}
                {...register("zipcode", { required: true })}
              />
              {errors.zipcode && (
                <span className="text-red text-xs ">
                  This field is required
                </span>
              )}
            </div>
          </div>
          <div className=" flex flex-col py-4 relative">
            <p className="text-white">What about you?</p>
            <p className="text-white">
              Describe yourself here in 200-300 words and explain why should we
              hire you.
            </p>
            <p className="text-white text-sm py-4">
              Take in account that your description may appear on our website
              and help customers choose you for their translation projects.
            </p>
            <textarea
              cols="30"
              rows="5"
              placeholder="Type yout text here"
              className="rounded pl-3 text-black py-1 mb-8"
              name="translator_comment"
              id="translator_comment"
              defaultValue={firstStepData.translator_comment}
              {...register("translator_comment")}
            ></textarea>
            <p className="text-white mb-12">
              If you encounter any problems signing up, Please{" "}
              <a
                href="https://www.tomedes.com/contactus.php"
                target="_blank"
                className="text-lightBlue"
              >
                Contact
              </a>
              &nbsp;us or&nbsp;
              <a
                href="https://server.iad.liveperson.net/hc/4900916/?cmd=file%C2%A0file=visitorWantsToChat%C2%A0site=4900916%C2%A0byhref=1%C2%A0imageUrl=https://server.iad.liveperson.net/hcp/Gallery/ChatButton-Gallery/English/General/1a/"
                className="text-lightBlue"
              >
                chat now
              </a>
              &nbsp;with our live agents.
            </p>
            <button
              className="bg-lightBlue text-white max-w-max rounded py-1 px-5 absolute right-0 bottom-0"
              // onClick={() => setCurrentStep(2)}
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FirstStepAccount;
